export const numberFormatter = {
    toStringWithDecimals: (value: number | null, minDigits = 2, maxDigits = 2): string => {
        if (value === null) return '-'

        return `${value.toLocaleString('de-DE', {
            minimumFractionDigits: minDigits,
            maximumFractionDigits: maxDigits
        })}`
    },

    toStringWithAmount: (value: number | null, codCurrency = '', minDigits = 2, maxDigits = 5): string => {
        if (value === null) return '-'

        return `${codCurrency} ${value.toLocaleString('de-DE', {
            minimumFractionDigits: minDigits,
            maximumFractionDigits: maxDigits
        })}`
    },

    toStringWithPercentage: (value: number | null, minDigits = 2, maxDigits = 5): string => {
        if (value === null) return '-'

        return `${value.toLocaleString('de-DE', {
            minimumFractionDigits: minDigits,
            maximumFractionDigits: maxDigits
        })} %`
    },

    toNumberWithoutDecimal: (value: number | null | undefined): number => {
        if (!value) return 0

        return value.toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }) as unknown as number
    },

    toCuitString: (value: string): string => {
        
        const primeraParte = value.substring(0, 2);
        const segundaParte = value.substring(2, 10);
        const terceraParte = value.substring(10);

        return `${primeraParte}-${segundaParte}-${terceraParte}`;
    },

    toListFromString: (value: string | null): number[] | undefined => {
        if (!value) return undefined

        const strArray: string[] = value.split(',')

        return strArray.map(x => parseInt(x))
    }
}
